import React from 'react';
import { Button } from 'antd';
import { ArrowLeftOutlined, BankOutlined, HeartOutlined, TeamOutlined, UserOutlined } from '@ant-design/icons';
import './Login.css';

/** Same keys AuthForm uses for its role tabs ("employer" is the organization role). */
export type AuthRole = 'student' | 'employer' | 'mentor' | 'sponsor';

export const AUTH_ROLES: { key: AuthRole; label: string; description: string; icon: React.ReactNode }[] = [
  { key: 'student', label: 'Student', description: 'Find internships, jobs and mentors', icon: <UserOutlined /> },
  { key: 'employer', label: 'Organization', description: 'Post opportunities and hire talent', icon: <BankOutlined /> },
  { key: 'mentor', label: 'Mentor', description: 'Guide the next generation', icon: <TeamOutlined /> },
  { key: 'sponsor', label: 'Sponsor', description: 'Support students and scholarships', icon: <HeartOutlined /> },
];

interface RoleTilesProps {
  title: string;
  subtitle: string;
  onSelect: (role: AuthRole) => void;
}

/** Step 1 of login / register: pick who you are before any form is shown. */
export const RoleTiles: React.FC<RoleTilesProps> = ({ title, subtitle, onSelect }) => (
  <div className="login-role-picker">
    <h2 className="login-role-title">{title}</h2>
    <p className="login-role-subtitle">{subtitle}</p>
    <div className="login-role-grid">
      {AUTH_ROLES.map((r) => (
        <button key={r.key} type="button" className="login-role-tile" onClick={() => onSelect(r.key)}>
          <span className="login-role-icon" aria-hidden="true">
            {r.icon}
          </span>
          <span className="login-role-label">{r.label}</span>
          <span className="login-role-desc">{r.description}</span>
        </button>
      ))}
    </div>
  </div>
);

interface RoleBarProps {
  role: AuthRole;
  onBack: () => void;
}

/** Step 2 header: back to the tiles, plus a chip showing the chosen role. */
export const RoleBar: React.FC<RoleBarProps> = ({ role, onBack }) => {
  const selected = AUTH_ROLES.find((r) => r.key === role);
  return (
    <div className="login-role-bar">
      <Button type="link" icon={<ArrowLeftOutlined />} onClick={onBack} className="login-role-back">
        Change role
      </Button>
      {selected && (
        <span className="login-role-chip">
          {selected.icon} {selected.label}
        </span>
      )}
    </div>
  );
};
